// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment__wrapper{position:relative}.comment__author{flex:1}.comment__datetime{display:flex;justify-content:flex-start}.comment__datetime>span:not(:last-child){padding-right:1rem}.comment__body{margin:1rem 0}", ""]);
// Exports
module.exports = exports;
